//export const BASE_URL = "http://localhost:8888/karuna-earth-observation/backend/public/index.php"
export const BASE_URL = "https://test.eo.backend.karuna.technology"

//export const GEE_URL = "http://localhost:8080"
export const GEE_URL = "https://re.karuna.technology"
